import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';
    
class LoginSettingsStore {
    @observable stepInProgress = false;
    @setter @observable credentialsButton;
    @setter @observable defaultLoginMethod;
    @setter @observable availableAuthMethods;
    
    @action toggleLoginCredentials() {
        this.credentialsButton = !this.credentialsButton;
    }

    @action changeDefaultLoginMethod(defaultLoginMethod) {
        this.defaultLoginMethod = defaultLoginMethod;
    }

    @action setLoginSettings() {
        return agent.TenantConfiguration.setLoginSettings(this.credentialsButton, this.defaultLoginMethod, this.availableAuthMethods)
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    }

    @action getLoginSettings() {
        return agent.TenantConfiguration.getLoginSettings()
        .then(action((data) => {
            this.credentialsButton = data.credentialsButton;
            this.defaultLoginMethod = data.defaultLoginMethod?.toUpperCase();
            this.availableAuthMethods = data.availableAuthMethods;
            }));
    }

    @action getDefaultLoginMethod() {
        return agent.TenantConfiguration.getDefaultLoginMethod()
        .then(action((data) => {
            this.credentialsButton = data.credentialsButton;
            this.defaultLoginMethod = data.defaultLoginMethod?.toUpperCase();
        }));
    }
}

export default new LoginSettingsStore();


// WEBPACK FOOTER //
// ./src/stores/loginSettingsStore.js